@if (store().goalsEnabled()) {
  <div class="bn-case-goal-links flex items-center gap-3 flex-wrap">
    <span class="bn-case-goal-links__label">Client goals</span>
    @for (goal of linkedGoals(); track goal.id) {
      <span class="bn-case-goal-links__pill">
        {{ goal.displayText }}
        <button
          type="button"
          class="bn-case-goal-links__unlink"
          [attr.aria-label]="'Unlink ' + goal.displayText"
          [disabled]="saving() || !store().canManageGoals()"
          (click)="unlinkGoal(goal.id)"
        >
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </span>
    }
    @if (saving()) {
      <span
        role="status"
        aria-label="Saving goal link"
        class="bn-case-goal-links__select flex items-center"
      >
        <i class="pi pi-spinner pi-spin" aria-hidden="true"></i>
      </span>
    } @else {
      <p-select
        class="bn-case-goal-links__select bn-care-plan-status-select"
        [options]="linkOptions()"
        optionLabel="label"
        optionValue="value"
        placeholder="Link goal"
        aria-label="Link a goal"
        appendTo="body"
        panelStyleClass="bn-care-plan-status-overlay"
        [ngModel]="selectedGoalId()"
        [disabled]="
          saving() || !store().canManageGoals() || linkOptions().length === 0
        "
        (ngModelChange)="onLinkGoal($event)"
      />
    }
    @if (error(); as message) {
      <p role="alert" class="text-sm m-0">{{ message }}</p>
    }
  </div>
}
